// extracted by mini-css-extract-plugin
module.exports = {"line":"_Index_line_1a5_h","layout-color":"_Index_layout-color_1cAHA","down-icon":"_Index_down-icon_1hXTD","footer-image":"_Index_footer-image_2pivy"};